<div class="encounter-wrapper" *ngIf="encounterDiaryHandler && encounterNoteHandler && encounterEmailHandler">
    <div class="encounter-id" *ngIf="(showMenu$ | async)">
        Encounter: {{encounter?.id}}
    </div> 
    <p-tabView>
        <p-tabPanel header="Notes">
            <app-encounter-notes-list [handler]="encounterNoteHandler" [encounter]="encounter" [notes]="encounter?.notes!"></app-encounter-notes-list>
        </p-tabPanel>
        <p-tabPanel header="Diaries">
            <app-diary-list [handler]="encounterDiaryHandler" [diaries]="encounter?.diaries!"></app-diary-list>
        </p-tabPanel>
        <p-tabPanel header="Emails">
            <app-email-manager [emailHandler]="encounterEmailHandler" [sentEmails]="encounter?.sentEmails!"></app-email-manager>
        </p-tabPanel>
        <p-tabPanel header="Attachments">
            <app-file-list [files]="encounter?.attachments!" [uploader]="uploader"></app-file-list>
        </p-tabPanel>
        <p-tabPanel header="Faxes">
            <app-fax-scroller [handler]="encounterFaxHandler" [faxes]="encounter?.outboundFaxes!"></app-fax-scroller>
        </p-tabPanel>
    </p-tabView>
</div>